module.exports = __webpack_public_path__ + "static/media/Adhesion.31e22532.pdf";